import DataListItem from '@/molecules/data-list-item';

import { DataList } from './DataList';

export type TypeDataList = typeof DataList & {
  Line: typeof DataListItem;
};

(DataList as TypeDataList).Line = DataListItem;

DataListItem.displayName = 'DataList.Line';

export type { TypeDataListProps } from './types';
export type { TypeDataListItemProps } from '@/molecules/data-list-item';

export default DataList as TypeDataList;
